import React from 'react';
import { Handshake, Lightbulb, Award, Trees } from 'lucide-react';
import { SECTIONS } from '@/constants/testIds';

const values = [
  { icon: Handshake, title: 'HONESTIDAD', text: 'Actuamos con transparencia y responsabilidad.' },
  { icon: Lightbulb, title: 'INNOVACIÓN', text: 'Buscamos constantemente nuevas formas de mejorar.' },
  { icon: Award, title: 'CALIDAD', text: 'La excelencia es un compromiso permanente.' },
  { icon: Trees, title: 'LEGADO', text: 'Trabajamos pensando en las próximas generaciones.' },
];

export default function Legado() {
  return (
    <section id="legado" data-testid={SECTIONS.legado} className="bg-[#EFE7D2] py-24">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <span className="font-cinzel text-[#A88340] text-xs tracking-[0.3em]">NUESTRO LEGADO</span>
          <h2 className="font-cormorant text-[#0F3527] text-4xl lg:text-5xl mt-4 mb-6 leading-tight">
            Aprender. Descubrir.<br/><em className="text-[#A88340] italic">Compartir.</em>
          </h2>
          <p className="text-[#0F3527]/85 text-base lg:text-lg leading-relaxed mb-4">
            Tres Cerritos es una empresa familiar construida sobre principios sólidos que guían
            cada decisión que tomamos.
          </p>
          <p className="text-[#0F3527]/85 text-base lg:text-lg leading-relaxed">
            Creemos que el verdadero legado son los conocimientos, sistemas y descubrimientos
            que dejamos para las próximas generaciones.
          </p>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v, i) => {
            const Icon = v.icon;
            return (
              <div key={i} className="text-center">
                <div className="w-14 h-14 mx-auto rounded-full bg-[#C9A361]/15 flex items-center justify-center mb-4 text-[#A88340]">
                  <Icon size={26} strokeWidth={1.5} />
                </div>
                <h3 className="font-cinzel text-[#0F3527] text-[13px] tracking-[0.2em] mb-2">{v.title}</h3>
                <p className="text-[#0F3527]/75 text-sm leading-relaxed">{v.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
